var map = {
	"./wse-workbooks-front-level-1.png": 404,
	"./wse-workbooks-front-level-10.png": 6271,
	"./wse-workbooks-front-level-11.png": 4716,
	"./wse-workbooks-front-level-12.png": 2417,
	"./wse-workbooks-front-level-13.png": 6864,
	"./wse-workbooks-front-level-14.png": 6647,
	"./wse-workbooks-front-level-15.png": 7351,
	"./wse-workbooks-front-level-16.png": 8722,
	"./wse-workbooks-front-level-17.png": 2787,
	"./wse-workbooks-front-level-18.png": 8154,
	"./wse-workbooks-front-level-19.png": 4102,
	"./wse-workbooks-front-level-2.png": 7937,
	"./wse-workbooks-front-level-20.png": 3930,
	"./wse-workbooks-front-level-3.png": 1629,
	"./wse-workbooks-front-level-4.png": 5493,
	"./wse-workbooks-front-level-5.png": 1878,
	"./wse-workbooks-front-level-6.png": 338,
	"./wse-workbooks-front-level-7.png": 3815,
	"./wse-workbooks-front-level-8.png": 9579,
	"./wse-workbooks-front-level-9.png": 7868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9999;